import { ServiceKind } from "@bitory-gmbh/bsm";

/**
 * processPath returns the path of the process. A process without a service
 * kind (null, or "" in a request) is an omni process, see
 * `process.Process.ServiceKind`, backend/core/processes/domain/process/process.go.
 */
export function processPath(
  serviceKind: ServiceKind | null | undefined,
  processId: string,
): string {
  const segment = !serviceKind ? "omni" : serviceKind.toLowerCase();
  return `/processes/${segment}/${processId}`;
}
